
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://figlvsuqeuzsutxdvcoi.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZpZ2x2c3VxZXV6c3V0eGR2Y29pIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU1ODczMDcsImV4cCI6MjA2MTE2MzMwN30.IsIlRgC-L96ITqP5xgTE0fW4bEWEuXROU5PWReskn6A";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
